import styled from "styled-components";

const CategoryProductsList = styled.ul<{isMobile: boolean | undefined}>`
    margin-top: ${props => props.isMobile ? "8" : "16"}px;
`

export default CategoryProductsList;